/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    code: "code",
    em: "em",
    a: "a",
    p: "p",
    del: "del"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Properties"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Properties"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "variant"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines the semantic purpose and subsequently the style of the visual helper. Will take precedence over the style_type prop"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "element"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " define what HTML element should be used. Defaults to ", _jsx(_components.code, {
              children: "<section>"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "breakout"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " use ", _jsx(_components.code, {
              children: "true"
            }), " to enable a fullscreen breakout look. Supports also media query breakpoints like ", _jsx(_components.code, {
              children: "{ small: boolean }"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "true"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "outline"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " define a custom border color. If ", _jsx(_components.code, {
              children: "true"
            }), " is given, ", _jsx(_components.code, {
              children: "color-black-8"
            }), " is used. Use a Eufemia ", _jsx(_components.a, {
              href: "/uilib/usage/customisation/colors/",
              children: "color"
            }), ". Supports also media query breakpoints like ", _jsx(_components.code, {
              children: "{ small: 'black-8' }"
            })]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "roundedCorner"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " use ", _jsx(_components.code, {
              children: "true"
            }), " to enable rounded corners (border-radius). Supports also media query breakpoints like ", _jsx(_components.code, {
              children: "{ small: boolean }"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "backgroundColor"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " define a custom background color, instead of a variant. Use a Eufemia ", _jsx(_components.a, {
              href: "/uilib/usage/customisation/colors/",
              children: "color"
            }), ". Supports also media query breakpoints like ", _jsx(_components.code, {
              children: "{ small: 'white' }"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dropShadow"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " use ", _jsx(_components.code, {
              children: "true"
            }), " to show the default Eufemia DropShadow. Supports also media query breakpoints like ", _jsx(_components.code, {
              children: "{ small: true }"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "textColor"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " define a custom text color to compliment the backgroundColor. Use a Eufemia ", _jsx(_components.a, {
              href: "/uilib/usage/customisation/colors/",
              children: "color"
            }), ". Supports also media query breakpoints like ", _jsx(_components.code, {
              children: "{ small: 'black-80' }"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "innerSpace"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " will add a padding around the content. Supports also media query breakpoints like ", _jsx(_components.code, {
              children: "{small: { top: 'medium' }}"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "innerRef"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " by providing a React Ref we can get the internally used element (DOM). E.g. ", _jsx(_components.code, {
              children: "inner_ref={myRef}"
            }), " by using ", _jsx(_components.code, {
              children: "React.createRef()"
            }), " or ", _jsx(_components.code, {
              children: "React.useRef()"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/uilib/layout/space/properties",
              children: "Space"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " spacing properties like ", _jsx(_components.code, {
              children: "top"
            }), " or ", _jsx(_components.code, {
              children: "bottom"
            }), " are supported."]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Variants"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Variant"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "info"
            })
          }), _jsx(_components.td, {
            children: "Neutral, informational."
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "error"
            })
          }), _jsx(_components.td, {
            children: "Indicates an erroneous state."
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "warning"
            })
          }), _jsx(_components.td, {
            children: "Draws attention to a potential problem that may or may not require an action on the user's part."
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "success"
            })
          }), _jsx(_components.td, {
            children: "Indicates a successful state."
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Styles"
    }), "\n", _jsxs(_components.p, {
      children: ["You can easily ", _jsx(_components.a, {
        href: "/uilib/components/section#customize-color",
        children: "customize the color"
      }), "."]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Style"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "white"
            })
          }), _jsxs(_components.td, {
            children: ["uses ", _jsx(_components.code, {
              children: "--color-white"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "divider"
            })
          }), _jsxs(_components.td, {
            children: ["uses ", _jsx(_components.code, {
              children: "--color-white"
            }), " as background with a border-line on top and bottom."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "transparent"
            })
          }), _jsx(_components.td, {
            children: "CSS transparent. Used in situations where a Section is of interest, but without a color as a basis."
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.del, {
              children: _jsx(_components.code, {
                children: "mint-green-12"
              })
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(default)"
            }), " uses ", _jsx(_components.code, {
              children: "--color-mint-green-12"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.del, {
              children: _jsx(_components.code, {
                children: "mint-green"
              })
            })
          }), _jsxs(_components.td, {
            children: ["uses ", _jsx(_components.code, {
              children: "--color-mint-green"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.del, {
              children: _jsx(_components.code, {
                children: "lavender"
              })
            })
          }), _jsxs(_components.td, {
            children: ["uses ", _jsx(_components.code, {
              children: "--color-lavender"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.del, {
              children: _jsx(_components.code, {
                children: "sand-yellow"
              })
            })
          }), _jsxs(_components.td, {
            children: ["uses ", _jsx(_components.code, {
              children: "--color-sand-yellow"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.del, {
              children: _jsx(_components.code, {
                children: "pistachio"
              })
            })
          }), _jsxs(_components.td, {
            children: ["uses ", _jsx(_components.code, {
              children: "--color-pistachio"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.del, {
              children: _jsx(_components.code, {
                children: "black-3"
              })
            })
          }), _jsxs(_components.td, {
            children: ["uses ", _jsx(_components.code, {
              children: "--color-black-3"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.del, {
              children: _jsx(_components.code, {
                children: "emerald-green"
              })
            })
          }), _jsxs(_components.td, {
            children: ["uses ", _jsx(_components.code, {
              children: "--color-emerald-green"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.del, {
              children: _jsx(_components.code, {
                children: "fire-red"
              })
            })
          }), _jsxs(_components.td, {
            children: ["uses ", _jsx(_components.code, {
              children: "--color-fire-red"
            }), ". Is used by ", _jsx(_components.a, {
              href: "/uilib/components/global-status",
              children: "GlobalStatus"
            })]
          })]
        })]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
